module.exports = __webpack_public_path__ + "img/content_Management.511ba066.svg";